/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Campaign translations init
 *
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.12.0
 */

import { IPageCampaignsForTypeOnly, IPageCampaignsTranslation } from '../../types/pages/campaigns';

const initTranslationForTypeOnly: IPageCampaignsForTypeOnly = {
    title: {
        prefilterLabel: '',
    },
};

const initPageCampaignsTranslation: IPageCampaignsTranslation = {
    forTypeOnly: {
        account: initTranslationForTypeOnly,
        subscriber: initTranslationForTypeOnly,
    },
    sideMenu: {
        account: '',
        subscriber: '',
    },
    table: {
        description: {
            header: '',
        },
        name: {
            header: '',
        },
    },
    title: {
        dropFilters: '',
        label: '',
    },
};


export default initPageCampaignsTranslation;
